import iconApplePay from 'assets/images/payment/icon-apple-pay.svg'
import iconGooglePay from 'assets/images/payment/icon-google-pay.svg'
import iconMastercard from 'assets/images/payment/icon-mastercard.svg'
import iconPaypal from 'assets/images/payment/icon-paypal.svg'
import iconVisa from 'assets/images/payment/icon-visa.svg'
import iconApplePayWhite from 'assets/images/payment/icon-apple-pay-white.svg'
import iconGooglePayWhite from 'assets/images/payment/icon-google-pay-white.svg'
export const PAYMENT_METHOD_ICONS = {
  visa: iconVisa,
  mastercard: iconMastercard,
  paypal: iconPaypal,
  applePay: iconApplePay,
  googlePay: iconGooglePay,
  applePayWhite: iconApplePayWhite,
  googlePayWhite: iconGooglePayWhite,
} as const
